// Browser audio unlock. Call only from a user gesture (click/tap).
let audioContext = null;
let unlocked = false;

export async function unlockAudio() {
    if (unlocked) return true;

    try {
        const Ctx = window.AudioContext || window.webkitAudioContext;
        if (!Ctx) {
            unlocked = true;
            return true;
        }

        audioContext = audioContext || new Ctx();
        if (audioContext.state === 'suspended') {
            await audioContext.resume().catch(() => {});
        }

        const buffer = audioContext.createBuffer(1, 1, 22050);
        const source = audioContext.createBufferSource();
        const gain = audioContext.createGain();
        gain.gain.value = 0.0001;
        source.buffer = buffer;
        source.connect(gain);
        gain.connect(audioContext.destination);
        source.start(0);

        unlocked = true;
        return true;
    } catch (error) {
        console.warn('[audio] unlock failed:', error?.name || error);
        return false;
    }
}
